enum TipoRecorrenciaEnum {
	SEMANAL = "SEMANAL",
	MENSAL = "MENSAL",
	ANUAL = "ANUAL",
}

export { TipoRecorrenciaEnum };
